import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type PopularTitleGraphqlFragment = { __typename?: 'PopularTitlesEdge' } & Pick<
	Types.PopularTitlesEdge,
	'cursor'
> & {
		node:
			| ({ __typename?: 'Movie' } & Pick<Types.Movie, 'id' | 'objectId' | 'objectType'> & {
						seenlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						content: { __typename?: 'MovieContent' } & Pick<
							Types.MovieContent,
							'title' | 'fullPath' | 'posterUrl' | 'isReleased'
						> & { scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'> };
						likelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						dislikelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchNowOffer?: Types.Maybe<
							{ __typename?: 'Offer' } & Pick<
								Types.Offer,
								| 'id'
								| 'standardWebURL'
								| 'retailPrice'
								| 'retailPriceValue'
								| 'lastChangeRetailPriceValue'
								| 'currency'
								| 'presentationType'
								| 'monetizationType'
								| 'availableTo'
							> & {
									package: { __typename?: 'Package' } & Pick<
										Types.Package,
										'id' | 'packageId' | 'clearName'
									>;
								}
						>;
					})
			| ({ __typename?: 'Show' } & Pick<Types.Show, 'id' | 'objectId' | 'objectType'> & {
						seenState: { __typename?: 'ShowSeenState' } & Pick<
							Types.ShowSeenState,
							'seenEpisodeCount' | 'progress'
						>;
						content: { __typename?: 'ShowContent' } & Pick<
							Types.ShowContent,
							'title' | 'fullPath' | 'posterUrl' | 'isReleased'
						> & {
								backdrops: Array<{ __typename?: 'Backdrop' } & Pick<Types.Backdrop, 'backdropUrl'>>;
								scoring: { __typename?: 'Scoring' } & Pick<Types.Scoring, 'imdbScore'>;
							};
						likelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						dislikelistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchlistEntry?: Types.Maybe<
							{ __typename?: 'TitleListEntry' } & Pick<Types.TitleListEntry, 'createdAt'>
						>;
						watchNowOffer?: Types.Maybe<
							{ __typename?: 'Offer' } & Pick<
								Types.Offer,
								| 'id'
								| 'standardWebURL'
								| 'retailPrice'
								| 'retailPriceValue'
								| 'lastChangeRetailPriceValue'
								| 'currency'
								| 'presentationType'
								| 'monetizationType'
								| 'availableTo'
							> & {
									package: { __typename?: 'Package' } & Pick<
										Types.Package,
										'id' | 'packageId' | 'clearName'
									>;
								}
						>;
					});
	};

export const PopularTitleGraphqlFragmentDoc = gql`
	fragment PopularTitleGraphql on PopularTitlesEdge {
		cursor
		node {
			id
			objectId
			objectType
			content(country: $country, language: $language) {
				title
				fullPath
				scoring {
					imdbScore
				}
				posterUrl(profile: $profile, format: $format)
				... on ShowContent {
					backdrops(profile: $backdropProfile, format: $format) {
						backdropUrl
					}
				}
				isReleased
			}
			likelistEntry {
				createdAt
			}
			dislikelistEntry {
				createdAt
			}
			watchlistEntry {
				createdAt
			}
			watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
				id
				standardWebURL
				package {
					id
					packageId
					clearName
				}
				retailPrice(language: $language)
				retailPriceValue
				lastChangeRetailPriceValue
				currency
				presentationType
				monetizationType
				availableTo
			}
			... on Movie {
				seenlistEntry {
					createdAt
				}
			}
			... on Show {
				seenState(country: $country) {
					seenEpisodeCount
					progress
				}
			}
		}
	}
`;
